/* MC-2850 Use enums for these to simplify the types */

export const MarketplaceProduct = Object.freeze({
  JIRA: 'jira',
  CONFLUENCE: 'confluence',
  COMPASS: 'compass'
});
export const AppInstallPermission = Object.freeze({
  CAN_INSTALL_FREE_AND_PAID: 'CAN_INSTALL_FREE_AND_PAID',
  CAN_INSTALL_FREE_ONLY: 'CAN_INSTALL_FREE_ONLY',
  CANNOT_INSTALL: 'CANNOT_INSTALL'
});
export const StargateCloudProduct = Object.freeze({
  HIPCHAT: 'hipchat.cloud',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  CONFLUENCE: 'confluence.ondemand',
  COMPASS: 'compass'
});
export const StargateAPIErrorCode = Object.freeze({
  UNAUTHORIZED: 'UNAUTHORIZED_ERROR',
  UNKNOWN: 'UNKNOWN_ERROR'
});
export const StargatePermissionId = Object.freeze({
  ADD_PRODUCTS: 'add-products',
  /** @deprecated Legacy. Use `ADD_PRODUCTS` instead */
  ADD_PRODUCT: 'addProduct',
  INVITE_USERS: 'invite-users',
  MANAGE: 'manage',
  WRITE: 'write'
});